"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectibleMinter = void 0;
var ethers_1 = require("ethers");
var frontend_provider_types_1 = require("@manifoldxyz/frontend-provider-types");
var types_1 = require("../types");
var errors_1 = require("./errors");
var utils_1 = require("./utils");
/**
 * CollectibleMinter is a class to help encapsulate the purchase functions since there is a handful
 * of steps needed to complete the purchase and dispatch the current state.
 */
var CollectibleMinter = /** @class */ (function () {
    function CollectibleMinter(collectibleContract, store, dataProviders) {
        this.collectibleContract = collectibleContract;
        this.store = store;
        this.dataProviders = dataProviders;
        this.mintTxManager = new CollectibleMintTxManager(collectibleContract, store, dataProviders);
    }
    CollectibleMinter.prototype.claim = function (params, options) {
        return __awaiter(this, void 0, void 0, function () {
            var onTxStateChange, _a, message, signature, nonce, overrides, tx, receipt, _b, tokens, numMintedTokens;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        onTxStateChange = function (transactionState) {
                            try {
                                options.onStateChange(transactionState);
                            }
                            catch (e) { }
                        };
                        return [4 /*yield*/, this.validateContractState(params)];
                    case 1:
                        _c.sent();
                        onTxStateChange({
                            status: 'ValidatingOnServer',
                        });
                        return [4 /*yield*/, this.getClaimEligibility(params.quantity)];
                    case 2:
                        _a = _c.sent(), message = _a.message, signature = _a.signature, nonce = _a.nonce;
                        return [4 /*yield*/, this.validateNonceUnused(nonce)];
                    case 3:
                        _c.sent();
                        onTxStateChange({
                            status: 'AwaitingSignature',
                        });
                        return [4 /*yield*/, this.mintTxManager.estimateGasForContractFn(params.quantity, function (payableOverrides) {
                                return _this.collectibleContract.estimateGasForClaim(params, message, signature, nonce, payableOverrides);
                            })];
                    case 4:
                        overrides = _c.sent();
                        return [4 /*yield*/, this.mintTxManager.executeContractFnWithErrorHandling(function () {
                                return _this.collectibleContract.claim(params, message, signature, nonce, overrides);
                            })];
                    case 5:
                        tx = _c.sent();
                        onTxStateChange({
                            status: 'Mining',
                            data: {
                                transactionHash: tx.hash,
                            },
                        });
                        return [4 /*yield*/, this.mintTxManager.confirm(tx)];
                    case 6:
                        receipt = _c.sent();
                        onTxStateChange({
                            status: 'Revealing',
                            data: {
                                transactionHash: tx.hash,
                            },
                        });
                        return [4 /*yield*/, this.mintTxManager.reveal(receipt)];
                    case 7:
                        _b = _c.sent(), tokens = _b.tokens, numMintedTokens = _b.numMintedTokens;
                        onTxStateChange({
                            status: 'Success',
                            data: {
                                numMintedTokens: numMintedTokens,
                                tokens: tokens,
                                transactionHash: tx.hash,
                            },
                        });
                        return [2 /*return*/, {
                                numMintedTokens: numMintedTokens,
                                tokens: tokens,
                                transactionHash: tx.hash,
                            }];
                }
            });
        });
    };
    CollectibleMinter.prototype.purchase = function (params, options) {
        return __awaiter(this, void 0, void 0, function () {
            var onTxStateChange, validation, message, signature, nonce, overrides, tx, receipt, _a, tokens, numMintedTokens;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        onTxStateChange = function (transactionState) {
                            try {
                                options.onStateChange(transactionState);
                            }
                            catch (e) { }
                        };
                        return [4 /*yield*/, this.validatePurchaseParams(params)];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.validateContractState(params)];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.validatePurchaseableAmount(params)];
                    case 3:
                        _b.sent();
                        onTxStateChange({
                            status: 'ValidatingOnServer',
                        });
                        return [4 /*yield*/, this.getServerPurchaseValidation(params)];
                    case 4:
                        validation = _b.sent();
                        message = validation.message, signature = validation.signature, nonce = validation.nonce;
                        return [4 /*yield*/, this.validateNonceUnused(nonce)];
                    case 5:
                        _b.sent();
                        onTxStateChange({
                            status: 'AwaitingSignature',
                        });
                        return [4 /*yield*/, this.mintTxManager.estimateGasForContractFn(params.quantity, function (payableOverrides) {
                                return _this.collectibleContract.estimateGasForPurchase(params, message, signature, nonce, payableOverrides);
                            })];
                    case 6:
                        overrides = _b.sent();
                        return [4 /*yield*/, this.mintTxManager.executeContractFnWithErrorHandling(function () {
                                return _this.collectibleContract.purchase(params, message, signature, nonce, overrides);
                            })];
                    case 7:
                        tx = _b.sent();
                        onTxStateChange({
                            status: 'Mining',
                            data: {
                                transactionHash: tx.hash,
                            },
                        });
                        return [4 /*yield*/, this.mintTxManager.confirm(tx)];
                    case 8:
                        receipt = _b.sent();
                        onTxStateChange({
                            status: 'Revealing',
                            data: {
                                transactionHash: tx.hash,
                            },
                        });
                        return [4 /*yield*/, this.mintTxManager.reveal(receipt)];
                    case 9:
                        _a = _b.sent(), tokens = _a.tokens, numMintedTokens = _a.numMintedTokens;
                        onTxStateChange({
                            status: 'Success',
                            data: {
                                numMintedTokens: numMintedTokens,
                                tokens: tokens,
                                transactionHash: tx.hash,
                            },
                        });
                        return [2 /*return*/, {
                                numMintedTokens: numMintedTokens,
                                tokens: tokens,
                                transactionHash: tx.hash,
                            }];
                }
            });
        });
    };
    CollectibleMinter.prototype.validatePurchaseParams = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!params.recaptchaToken) {
                    throw new errors_1.InvalidPurchaseArgumentsError('`recaptchaToken` is required for purchase');
                }
                if (!params.quantity) {
                    throw new errors_1.InvalidPurchaseArgumentsError('`quantity` is required for purchase');
                }
                return [2 /*return*/];
            });
        });
    };
    CollectibleMinter.prototype.validatePurchaseableAmount = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (params.quantity > this.store.state.purchaseableAmount) {
                    throw new errors_1.TooManyRequestedError('Too many items requested');
                }
                return [2 /*return*/];
            });
        });
    };
    CollectibleMinter.prototype.validateContractState = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.store.state.active) {
                    throw new errors_1.ContractDeactivatedError('Contract is not active');
                }
                if (!this.store.state.tokensRemaining) {
                    throw new errors_1.SoldOutError('Collection is sold out');
                }
                if (this.store.state.tokensRemaining < params.quantity) {
                    throw new errors_1.NotEnoughInventoryError('Not enough inventory remaining');
                }
                return [2 /*return*/];
            });
        });
    };
    CollectibleMinter.prototype.getClaimEligibility = function (amount) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.dataProviders.collectibleServerAPI.getClaimEligibility(this.store.state.collectibleId, this.store.state.walletAddress, amount)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleMinter.prototype.getServerPurchaseValidation = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.store.state.salePhase === types_1.SalePhase.PRESALE)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.dataProviders.collectibleServerAPI.getPresaleValidation(this.store.state.collectibleId, this.store.state.walletAddress, params.recaptchaToken, params.quantity)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [4 /*yield*/, this.dataProviders.collectibleServerAPI.getValidation(this.store.state.collectibleId, this.store.state.walletAddress, params.recaptchaToken)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleMinter.prototype.validateNonceUnused = function (nonce) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.collectibleContract.hasNonceBeenUsed(nonce)];
                    case 1:
                        if (_a.sent()) {
                            throw new errors_1.NonceUsedError('Transaction nonce already used');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return CollectibleMinter;
}());
exports.CollectibleMinter = CollectibleMinter;
var CollectibleMintTxManager = /** @class */ (function () {
    function CollectibleMintTxManager(collectibleContract, store, dataProviders) {
        this.collectibleContract = collectibleContract;
        this.store = store;
        this.dataProviders = dataProviders;
    }
    CollectibleMintTxManager.prototype.estimateGasForContractFn = function (quantity, contractFn) {
        return __awaiter(this, void 0, void 0, function () {
            var overrides, gasEstimate, minGasEstimate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        overrides = {
                            from: this.store.state.walletAddress,
                            value: this.getPrice(quantity),
                        };
                        return [4 /*yield*/, contractFn(overrides)];
                    case 1:
                        gasEstimate = _a.sent();
                        minGasEstimate = ethers_1.BigNumber.from('230000').add(ethers_1.BigNumber.from('110000').mul(ethers_1.BigNumber.from(quantity - 1)));
                        overrides.gasLimit = gasEstimate.lt(minGasEstimate)
                            ? minGasEstimate
                            : // Multiply gas estimate by 1.25 to account for inaccurate estimates from Metamask.
                                gasEstimate.mul(125).div(100);
                        return [2 /*return*/, overrides];
                }
            });
        });
    };
    CollectibleMintTxManager.prototype.executeContractFnWithErrorHandling = function (fn) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, fn()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_1 = _a.sent();
                        if (e_1.code === 4001 || e_1.code === 'ACTION_REJECTED') {
                            throw new errors_1.UserRejectedError('User rejected request');
                        }
                        if (e_1.message.toLowerCase().search('trezor') >= 0 ||
                            e_1.message.toLowerCase().search('ledger') >= 0) {
                            throw new errors_1.HardwareWalletError(e_1.message.replace('execution reverted: ', ''));
                        }
                        throw new errors_1.ContractCallError(e_1.message.replace('execution reverted: ', ''));
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    CollectibleMintTxManager.prototype.confirm = function (tx) {
        return __awaiter(this, void 0, void 0, function () {
            var receipt;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, tx.wait()];
                    case 1:
                        receipt = _a.sent();
                        if (receipt.status !== 1) {
                            throw new errors_1.ContractCallError("Received status \"".concat(receipt.status, "\" in transaction receipt, expected \"1\""));
                        }
                        return [2 /*return*/, receipt];
                }
            });
        });
    };
    CollectibleMintTxManager.prototype.reveal = function (receipt) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, unrevealedTokens, numMintedTokens, tokens;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.collectibleContract.parseMintedTokensFromTransactionReceipt(receipt), unrevealedTokens = _a.tokens, numMintedTokens = _a.numMintedTokens;
                        return [4 /*yield*/, Promise.all(unrevealedTokens.map(function (token) { return _this.fetchTokenWithRetry(token); }))];
                    case 1:
                        tokens = _b.sent();
                        return [2 /*return*/, {
                                tokens: tokens,
                                numMintedTokens: numMintedTokens,
                            }];
                }
            });
        });
    };
    CollectibleMintTxManager.prototype.fetchTokenWithRetry = function (_a, retryAttempt) {
        var collectibleAddress = _a.collectibleAddress, collectibleInstanceId = _a.collectibleInstanceId, tokenId = _a.tokenId;
        if (retryAttempt === void 0) { retryAttempt = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var collectibleId, token, domain, openseaUrl;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        collectibleId = (0, utils_1.formatCollectibleId)(collectibleAddress, collectibleInstanceId);
                        return [4 /*yield*/, this.dataProviders.collectibleServerAPI.fetchToken(collectibleId, collectibleAddress, tokenId)];
                    case 1:
                        token = _b.sent();
                        if (!(token.unrevealed &&
                            !token.isCollectibleMetadataHidden &&
                            this.store.state.contractType === 'erc721')) return [3 /*break*/, 3];
                        // Give up retrying after a while
                        if (retryAttempt > 30) {
                            throw new errors_1.RevealTokenError("Unable to reveal token with ID: ".concat(tokenId));
                        }
                        // Wait a bit and then try again.
                        return [4 /*yield*/, new Promise(function (resolve) {
                                return setTimeout(function () {
                                    resolve(null);
                                }, 5000);
                            })];
                    case 2:
                        // Wait a bit and then try again.
                        _b.sent();
                        return [2 /*return*/, this.fetchTokenWithRetry({ collectibleAddress: collectibleAddress, collectibleInstanceId: collectibleInstanceId, tokenId: tokenId }, retryAttempt + 1)];
                    case 3:
                        domain = this.store.state.network === frontend_provider_types_1.EthereumNetwork.MAINNET ? 'opensea.io' : 'testnets.opensea.io';
                        openseaUrl = "https://".concat(domain, "/assets/").concat(collectibleAddress, "/").concat(tokenId);
                        return [2 /*return*/, __assign(__assign({}, token), { tokenId: tokenId, contractAddress: collectibleAddress, openseaUrl: openseaUrl })];
                }
            });
        });
    };
    CollectibleMintTxManager.prototype.getPrice = function (quantity) {
        return ethers_1.BigNumber.from(this.store.state.currentPriceWithMintFee).mul(ethers_1.BigNumber.from(quantity));
    };
    return CollectibleMintTxManager;
}());
